import { render, staticRenderFns } from "./SignUpNaturalForm.vue?vue&type=template&id=453255bc"
import script from "./SignUpNaturalForm.vue?vue&type=script&lang=js"
export * from "./SignUpNaturalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports